import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-delivery-date',
    imports: [CommonModule],
    templateUrl: './delivery-date.component.html',
    styleUrls: ['./delivery-date.component.scss']
})
export class DeliveryDateComponent {
  @Input() public deliveryDate?: Date | undefined;
}
